var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6101 6.11997L6.17014 2.42664C5.82167 2.22541 5.42614 2.12 5.02374 2.1211C4.62134 2.12221 4.22639 2.22979 3.87903 2.43293C3.53166 2.63607 3.24425 2.92752 3.04597 3.27769C2.8477 3.62786 2.74563 4.02426 2.75014 4.42664V11.84C2.75014 12.4447 2.99036 13.0246 3.41794 13.4522C3.84552 13.8798 4.42545 14.12 5.03014 14.12C5.43043 14.1193 5.82353 14.0135 6.17014 13.8133L12.6101 10.12C12.9562 9.9197 13.2435 9.63195 13.4432 9.2856C13.6429 8.93924 13.7481 8.54645 13.7481 8.14664C13.7481 7.74682 13.6429 7.35404 13.4432 7.00768C13.2435 6.66133 12.9562 6.37358 12.6101 6.17331V6.11997ZM11.9435 8.9133L5.50348 12.66C5.35913 12.7418 5.19605 12.7848 5.03014 12.7848C4.86423 12.7848 4.70115 12.7418 4.55681 12.66C4.41287 12.5769 4.29335 12.4573 4.21027 12.3134C4.12718 12.1695 4.08345 12.0062 4.08348 11.84V4.39997C4.08345 4.23377 4.12718 4.07049 4.21027 3.92655C4.29335 3.7826 4.41287 3.66307 4.55681 3.57997C4.70175 3.49941 4.86434 3.4559 5.03014 3.45331C5.19583 3.45671 5.35823 3.50017 5.50348 3.57997L11.9435 7.29997C12.0875 7.38304 12.207 7.50255 12.2902 7.6465C12.3733 7.79044 12.4171 7.95374 12.4171 8.11997C12.4171 8.2862 12.3733 8.4495 12.2902 8.59345C12.207 8.73739 12.0875 8.85691 11.9435 8.93997V8.9133Z",
    fill: "#346C75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.3506510e5c960df64776e0f3d96bd0f8.svg";
export { ForwardRef as ReactComponent };